import { render, staticRenderFns } from "./ClientAnalytics.vue?vue&type=template&id=d27b3658&"
import script from "./ClientAnalytics.vue?vue&type=script&lang=js&"
export * from "./ClientAnalytics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports